import moment from 'moment';

/**
 * Formats a date or returns a string if not available
 *
 * @param {date} date
 *
 * @returns {string} - formatted date.
 */
const formatDate = (date) => {
  if (!date) return '-';
  return moment(date, 'YYYY-MM-DD', 'hh:mm:ss').format('MM-DD-YYYY');
};

export default formatDate;
